import { render, staticRenderFns } from "./ManageTournament.vue?vue&type=template&id=17d81e96&scoped=true&"
import script from "./ManageTournament.vue?vue&type=script&lang=js&"
export * from "./ManageTournament.vue?vue&type=script&lang=js&"
import style0 from "./ManageTournament.vue?vue&type=style&index=0&id=17d81e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d81e96",
  null
  
)

export default component.exports